import React, { useEffect, useState } from 'react';
import { IMAGE_UPLOAD_URL, POPUP_ENABLED } from '../config';

const POPUP_STORAGE_KEY = 'citizen_welcome_popup_seen';

export default function WelcomePopup() {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!POPUP_ENABLED) {
      return;
    }

    const hasSeenPopup = sessionStorage.getItem(POPUP_STORAGE_KEY);
    if (!hasSeenPopup) {
      setIsOpen(true);
    }
  }, []);

  const closePopup = () => {
    sessionStorage.setItem(POPUP_STORAGE_KEY, 'true');
    setIsOpen(false);
  };

  if (!POPUP_ENABLED || !isOpen) {
    return null;
  }

  return (
    <div
      className="welcome-popup-overlay"
      onClick={closePopup}
      role="presentation"
    >
      <div
        className="welcome-popup-content"
        onClick={(event) => event.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label="Site announcement"
      >
        <button
          type="button"
          className="welcome-popup-close"
          onClick={closePopup}
          aria-label="Close announcement"
        >
          &times;
        </button>
        <img src={IMAGE_UPLOAD_URL} alt="Important announcement from Citizen" />
      </div>
    </div>
  );
}
